import * as B from '@blueprintjs/core';
import React from 'react';

import cs from 'app/pages/ManageProperties/styles.module.scss';
import {exportGeoJson} from 'app/utils/geoJsonUtils';
import {stripBackendValidationProps} from 'app/utils/polygonSplit';

interface ErrorFeature {
  geometry: GeoJSON.Geometry;
  properties: GeoJSON.GeoJsonProperties;
}

interface ErrorPropertiesCalloutProps {
  featuresWithErrors: ErrorFeature[];
  downloadFilename: string;
  warningsCount?: number;
}

const ErrorPropertiesCallout: React.FC<ErrorPropertiesCalloutProps> = ({
  featuresWithErrors,
  downloadFilename,
  warningsCount = 0,
}) => {
  const errorCount = featuresWithErrors.length;

  if (errorCount === 0 && warningsCount === 0) {
    return null;
  }

  return (
    <B.Callout className={cs.callout} intent={B.Intent.WARNING} icon={null}>
      {errorCount > 0 && (
        <div className={cs.errorRow}>
          <>
            {errorCount} {errorCount === 1 ? 'property has' : 'properties have'} errors and will not
            be included in upload.
          </>
          <B.Tooltip content="Download properties with errors as GeoJSON">
            <B.Button
              minimal
              small
              intent={B.Intent.WARNING}
              text="Download"
              onClick={() => {
                exportGeoJson(
                  {
                    type: 'FeatureCollection',
                    features: featuresWithErrors.map((f) => ({
                      type: 'Feature' as const,
                      geometry: f.geometry,
                      properties: stripBackendValidationProps(f.properties),
                    })),
                  },
                  downloadFilename
                );
              }}
            />
          </B.Tooltip>
        </div>
      )}
      {warningsCount > 0 && (
        <div>
          Please review the {warningsCount} {warningsCount > 1 ? 'warnings' : 'warning'} in the
          table above before proceeding.{' '}
        </div>
      )}
    </B.Callout>
  );
};

export default ErrorPropertiesCallout;
